export const status = {
  null: { label: "Draft", class: "bg-gray-200 text-black" },
  "": { label: "Draft", class: "bg-gray-200 text-black" },
  draft: { label: "Draft", class: "bg-gray-200 text-black" },
  sent: { label: "Sendt", class: "bg-blue-100 text-blue-800" },
  confirmed: { label: "Bekreftet", class: "bg-yellow-100 text-yellow-800" },
  received: { label: "Mottatt", class: "bg-green-100 text-green-800" },
  new: { label: "New", class: "bg-yellow-200 text-green-800" },
  NEW: { label: "New", class: "bg-yellow-200 text-green-800" },
  ongoing: { label: "Ongoing", class: "bg-green-100 text-green-800" },
  ONGOING: { label: "Ongoing", class: "bg-green-100 text-green-800" },
  accomplished: { label: "Accomplished", class: "bg-green-600 text-white" },
  ACCOMPLISHED: { label: "Accomplished", class: "bg-green-600 text-white" },
  finished: { label: "Finished", class: "bg-green-600 text-white" },
  FINISHED: { label: "Finished", class: "bg-green-600 text-white" },
  processing: { label: "Processing", class: "bg-yellow-600 text-white" },
  PROCESSING: { label: "Processing", class: "bg-yellow-600 text-white" },
  processed: { label: "Processed", class: "bg-blue-600 text-white" },
  closed: { label: "Closed", class: "bg-gray-600 text-white" },
  CLOSED: { label: "Closed", class: "bg-gray-600 text-white" },
  cancelled: { label: "Cancelled", class: "bg-red-600 text-white" },
  ready_invoice: {
    label: "Ready to be invoiced",
    class: "bg-red-600 text-white"
  },
  invoiced: { label: "Invoiced", class: "bg-indigo-600 text-white" },
  INVOICED: { label: "Invoiced", class: "bg-indigo-600 text-white" },
  paid: { label: "Paid", class: "bg-green-600 text-white" },
  inactive: { label: "Inactive", class: "bg-yellow-400 text-white" },
  active: { label: "Active", class: "bg-green-600 text-white" },
  pending: { label: "Pending", class: "bg-yellow-600 text-white" },
  approved: { label: "Approved", class: "bg-green-600 text-white" },
  not_approved: { label: "Not Approved", class: "bg-red-600 text-white" },
  updated_after_process: { label: "Updated - Pending Review", class: "bg-yellow-600 text-white" },
  pending_approval: { label: "Pending Approval", class: "bg-blue-600 text-white" },
  PICKED: { label: "Picked", class: "bg-green-600 text-white" },
  PACKED: { label: "Packed", class: "bg-green-600 text-white" },
  READY_FOR_SHIPPING: {
    label: "Ready to be shipped",
    class: "bg-green-600 text-white"
  },
  READY_FOR_INVOICING: {
    label: "Ready to be invoiced",
    class: "bg-green-600 text-white"
  },
  READY_FOR_PICKING: {
    label: "Ready to be picked",
    class: "bg-green-600 text-white"
  },
  CONFIRMATION_SENT: {
    label: "Order Confirmation Sent",
    class: "bg-green-600 text-white"
  },
  ASSIGNED: {
    label: "Assigned",
    class: "bg-yellow-600 text-white"
  },
  ACCEPTED: {
    label: "Accepted",
    class: "bg-green-600 text-white"
  },
  employee: { label: "Employees", class: "bg-blue-100 text-blue-800" },
  driver: { label: "Drivers", class: "bg-green-100 text-green-800" },
  admin: { label: "Administrators", class: "bg-red-100 text-red-800" },
  moderator: { label: "Moderators", class: "bg-purple-100 text-purple-800" },
  cases: { label: "Cases", class: "bg-yellow-100 text-yellow-800" },
  vehicles: { label: "Vehicles", class: "bg-indigo-100 text-indigo-800" },
  checklists: { label: "Checklists", class: "bg-pink-100 text-pink-800" },
  tasks: { label: "Tasks", class: "bg-orange-100 text-orange-800" },
  service: { label: "Service", class: "bg-teal-100 text-teal-800" },
  sales: { label: "Sales", class: "bg-cyan-100 text-cyan-800" },
  purchase: { label: "Purchase", class: "bg-lime-100 text-lime-800" },
  hse: { label: "HSE", class: "bg-emerald-100 text-emerald-800" },
  customers: { label: "Customers", class: "bg-violet-100 text-violet-800" },
  projects: { label: "Projects", class: "bg-rose-100 text-rose-800" },
  edit_projects: { label: "Edit Projects", class: "bg-sky-100 text-sky-800" },
  items: { label: "Items", class: "bg-amber-100 text-amber-800" },
  item_consumption: {
    label: "Item Consumption",
    class: "bg-fuchsia-100 text-fuchsia-800"
  },
  articles: { label: "Articles", class: "bg-stone-100 text-stone-800" },
  absences: { label: "Absences", class: "bg-slate-100 text-slate-800" },
  edit_absences: { label: "Edit Absences", class: "bg-zinc-100 text-zinc-800" },
  hours: { label: "Hours", class: "bg-neutral-100 text-neutral-800" },
  hours_overview: { label: "hours.company_overview", class: "bg-sky-100 text-sky-800" },
  edit_hours: { label: "Edit Hours", class: "bg-gray-100 text-gray-800" },
  approve_supplierinvoices: {
    label: "Approve Supplier Invoices",
    class: "bg-red-100 text-red-800"
  },
  REJECTED: {
    label: "Rejected",
    class: "bg-red-600 text-white"
  },
  rejected: {
    label: "Rejected",
    class: "bg-red-600 text-white"
  },
  APPROVED: {
    label: "Approved",
    class: "bg-green-600 text-white"
  },
  NOT_APPROVED: {
    label: "Not Approved",
    class: "bg-red-600 text-white"
  },
  UPDATED: {
    label: "Updated",
    class: "bg-blue-600 text-white"
  },
  updated: {
    label: "Updated",
    class: "bg-blue-600 text-white"
  },
  ended: {
    label: "Ended",
    class: "bg-gray-600 text-white"
  },
  unknown: {
    label: "Unknown",
    class: "bg-gray-600 text-white"
  },
  abandoned: {
    label: "Abandoned",
    class: "bg-red-600 text-white"
  },
  answered: {
    label: "Answered"
  }
};
